import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { message } from 'ant-design-vue'
import store from "@/store";
import Cookies from 'js-cookie'
import { getParams, getHeader } from "@/utils/sign";
import { $deepclone } from '@/utils/methods';

const maxConcurrentRequests = 10; // 最大同时请求数量

const requestQueue = []; // 请求队列，用于存储待发送的请求
let activeRequests = 0; // 当前活跃的请求数量

const addSignWhiteList = [
  "/authorityservice/user/resetPasswordEmail",
  "/authorityservice/user/updatePassword",
  "/authorityservice/user/sendVerifyEmail",
  "/authorityservice/user/registerUser",
  "/authorityservice/auth/login",
  "/authorityservice/auth/logout",
  "/authorityservice/user/innerUserRegister",
  "/accountservice/airwallex/recharge/weixinRecharge",
  "/accountservice/airwallex/recharge/getRechargeDetail",
  "/complexservice/intentUser/saveIntentUser"
];

// create an axios instance
const service = axios.create({
  baseURL: '/api',
  // timeout: 5000
});

// request interceptor
// let loadingInstance;
// let loadCount = 0;
service.interceptors.request.use(
  async conf => {
    const c = await new Promise((resolve, reject) => {
      let config = $deepclone(conf)
      if(store.getters.ttUserId) {
        if(config.params) {
          config.params.tt_user_id = store.getters.ttUserId
        } else {
          config.params = {
            tt_user_id: store.getters.ttUserId
          }
        }
      }
      // 如果活跃的请求数量小于最大同时请求数量，直接发送请求
      if (activeRequests < maxConcurrentRequests) {
        activeRequests++;
        resolve(config);
      } else {
        // 否则，将请求加入队列，并在延迟后再发送
        const uniqueId = uuidv4();
        requestQueue.push(uniqueId);
        // 定时检测队列和当前活跃请求数
        const t = setInterval(() => {
          if(requestQueue[0] === uniqueId&&activeRequests < maxConcurrentRequests) {
            activeRequests++;
            requestQueue.shift()
            resolve(config);
            clearInterval(t)
          }
        }, 100);
      }
    })
    return encryptConfig(c)
  },
  error => {
    // setTimeout(() => {
    //   loadCount--;
    //   if (!loadCount) loadingInstance.close();
    // });
    console.log(error, 'requestrequest')
    message.error(res.msg || res.message)

    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    // 请求成功时的处理
    activeRequests--;
    // 响应成功关闭loading
    // setTimeout(() => {
    //   loadCount--;
    //   if (!loadCount) loadingInstance.close();
    // });
    const res = response.data;
    if (
      res.code === 200 ||
      res.code === 500100 ||
      res.code === 400 ||
      res.code === 402 ||
      res.code === 204 || 
      response.config.responseType === "blob"
    ) {
      return res;
    } else if (res.code === 403 || res.code == 405 || res.code === 401) {
      store.dispatch("user/logout")
      return Promise.reject(new Error(res.msg || "Error"));
    }else {
      // 与后端约定501 为错误但不提示消息
      if(res.code !== 501){
        message.error(res.msg || res.message)
      }
      return Promise.reject(new Error(res.msg || "Error"));
    }
  },
  error => {
    // 请求出错时的处理
    activeRequests--;

    console.log("err11111" + error); // for debug
    // 响应成功关闭loading
    // setTimeout(() => {
    //   loadCount--;
    //   if (!loadCount) loadingInstance.close();
    // });

    message.error(error.msg || error.message)
    return Promise.reject(error);
  }
);


// 加密
function encryptConfig(conf) {
  let config = $deepclone(conf)
  let encryptData = ''
  if (!addSignWhiteList.includes(config.url) && config.url.indexOf('/templateShareInfo/without') === -1) {
    if (config.params || !config.data) {
      config.params = {
        ...config.params
      };
      encryptData = getParams(config.params);
      config.params = {
        data: encryptData
      }
      if (config.method !== "get" && config.method !== "GET") {
        config.params = { data: decodeURIComponent(config.params.data)};
      }
    }
    if (config.data) {
      const isFormData = v => {
        return Object.prototype.toString.call(v) === "[object FormData]";
      };
      if (isFormData(config.data)) {
        const newData = new FormData();
        // const _data = {};
        // for (var key of config.data.keys()) {
        //   if (Object.prototype.toString.call(config.data.get(key)) === "[object File]") {
        //     newData.append(key, config.data.get(key));
        //   } else {
        //     _data[key] = config.data.get(key);
        //   }
        // }
        // newData.append("data", getParams(_data).data);
        // encryptData = getParams(_data)
        encryptData = getParams(config.params || {
          _t: new Date().getTime()
        })
        config.params = { data: decodeURIComponent(encryptData)};
        // config.data = newData;
      } else {
        encryptData = getParams(config.data)
        config.data = { data: encryptData };
      }
    }
  }
  config.headers = { ...config.headers, ...getHeader(config.url, encryptData) };
  config.headers.TGC = Cookies.get('TGC')
  console.log(config)
  return config
}

export default service;
